import React, { useContext, useEffect, useState } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Navbar from "../Components/Navbar";
import Navbar2 from "../Components/Navbar2";
import Sidebar from "../Components/Sidebar";
import Sidebar2 from "../Components/Sidebar2";
import Overview from "../Pages/overview";
import Overview2 from "../Pages/oerview2";

import ConstituencyManagement from "../Pages/cdm";
import Users from "../Pages/users";
import Reports from "../Pages/reports";
import Insights from "../Pages/insights";
import HelpCenter from "../Pages/HelpCenter";
import Survey from "../Pages/survey";
import CustomerSupport from "../Pages/customerSupport";
import Tabsettings from "../Pages/settings/Tabsettings";
import Notifications from "../Pages/notifications/Notifications";
import Login from "../Components/services/Login";
import ForgotPassword from "../Components/services/ForgotPassword";
import { AppContext } from "../context/AppContextProvider";
import ClientUser from "../Components/assetsManagement/user/ClientUser";
import GmsTab from "../Pages/gms";
import AssetsManagement from "../Pages/assetsManagement";
import Tms from "../Pages/tms";
import TmsList from "../Pages/tms/TmsList";
import TmsMapBox from "../Pages/tms/MapBox";
import UserInfo from "../Components/assetsManagement/userInfo/userInfo";
// import IssueDetails from "../Pages/gms/IssueDetails";
import IssueDetails from "../Pages/gms/IssueDetails";
import TmsDetails from "../Pages/tms/TmsDetails";
import SubscriptionMessage from "../utils/SubscriptionMessage";
import GrievanceUserInfo from "../Components/assetsManagement/userInfo/GrievanceUserInfo";
import TaskUserInfo from "../Components/assetsManagement/userInfo/TaskUserInfo";
import SurveyDownload from "../Components/survey/SurveyDownload";
import ReportDownload from "../Components/reports/ReportDownload";
import ResetPassword from "../Components/services/ResetPassword";
import SocialMedia from "../Pages/socialMedia/index";
import Directory from "../Pages/directory";
import Chat from "../Pages/Chat";
import Constituency from "../Components/cdm/Constituency";
import EventScheduler from "../Pages/eventScheduler";
import PowerBIModule from "../Pages/powerbiModule/PowerBIModule";
import PowerBiReportPage from "../Components/powerbiModule/PowerBiReportPage";
import SpeechModule from "../Pages/speech/index"
import SpeechReportPage from "../Components/speech/SpeechReportPage";
import ElectionModeFullScreen from "../Components/ElectionMode/ElectionModeFullScreen";
import MediaIntelligence from "../Pages/mediaIntelligence";

// import CustomerSupport from "../Pages/customerSupport"
// import OrganizationalHierarchy from "../Components/assetsManagement/organizationalHierarchy/OrganizationalHierarchy";

const RouteApp = () => {
  const { isLoggedIn, user } = useContext(AppContext);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const activeUser = user || storedUser;
  const subscriptions = user?.subscription?.map((item) => item?.name) || [];
  const isElectionMode =
    localStorage.getItem("isElectionMode") === "true" ||
    activeUser?.isElectionMode === true;
  // const getHashPath = () =>
  //   (window.location.hash.replace(/^#/, "").split("?")[0] || "/");
  // const [currentPath, setCurrentPath] = useState(getHashPath);
  // const defaultRoute = isElectionMode ? "/election-mode" : "/dashboardtest";

  // useEffect(() => {
  //   const handleHashChange = () => setCurrentPath(getHashPath());
  //   window.addEventListener("hashchange", handleHashChange);
  //   return () => window.removeEventListener("hashchange", handleHashChange);
  // }, []);
  // console.log({ subscriptions });

  return (
    <Router>
      {isLoggedIn ? (
        <>
          <Navbar2 />
          <div
            className="grid-container">
            <div className="grid-child w-[5.5rem]">
              {/* <Sidebar2 role={activeUser?.role} /> */}
              <Sidebar2 role={user?.role} />
            </div>

            <div className="grid-child main-container w-[100%]">
              <Routes>
                {!isElectionMode && ["data_entry_operator", "office_manager", "cadre"].includes(
                  user?.role
                ) ? (
                  <Route path="*" element={<Navigate to="/gms" replace />} />
                ) : (
                  
                  // <Route
                  //   path="*"
                  //   // element={<Navigate to={defaultRoute} replace />}
                  //   element={<Navigate to="/dashboardtest" replace />}
                  // />
                  <Route
                    path="/election-mode"
                    element={
                      isElectionMode ? (
                        <ElectionModeFullScreen user={activeUser} />
                      ) : (
                        <Navigate to="/dashboardtest" replace />
                      )
                    }
                  />
                )}
                <Route path="/media-intelligence" element={<MediaIntelligence />} />
                <Route exact path="/dashboardtest" element={<Overview2 />} />
                <Route path="/helpcenter" element={<HelpCenter />} />
                <Route path="/users" element={<Users />} />
                <Route path="/clientuser" element={<ClientUser />} />
                {/* <Route path='/cadremanagment' element={<Cadre />} /> */}
                <Route
                  path="/cdm"
                  element={
                    subscriptions.includes("CDM") ? (
                      <ConstituencyManagement />
                    ) : (
                      <SubscriptionMessage />
                    )
                  }
                />
                <Route
                  path="assembly/view-constituency/:selectedYear"
                  element={<Constituency />}
                />
                {subscriptions.includes("GMS") ? (
                  <Route path="/gms">
                    <Route index element={<Navigate to="gms" replace />} />
                    <Route path=":source" element={<GmsTab />} />

                    <Route
                      path="issuedetails/:grievanceId"
                      element={<IssueDetails />}
                    />
                  </Route>
                ) : (
                  <Route path="/gms" element={<SubscriptionMessage />} />
                )}
                {/* <Route path='/gms/issuedetails/:grievanceId' element={<IssueDetails />} /> */}
                {subscriptions.includes("TMS") ? (
                  <>
                    <Route path="/tms" element={<Tms />}>
                      <Route path="list" element={<TmsList />} />
                      <Route path="map" element={<TmsMapBox />} />
                    </Route>
                    <Route
                      path="/tms/taskdetails/:taskId"
                      element={<TmsDetails />}
                    />
                  </>
                ) : (
                  <Route path="/tms" element={<SubscriptionMessage />} />
                )}
                {/* <Route
                  path='/reports'
                  element={
                    subscriptions.includes("Reports") ? (
                      <Reports />
                    ) : (
                      <SubscriptionMessage />
                    )
                  }
                /> */}
                {subscriptions.includes("Reports") ? (
                  <>
                    <Route path="/reports">
                      <Route
                        index
                        element={<Navigate to="report-database" replace />}
                      />
                      <Route path=":source" element={<Reports />} />
                      <Route
                        path="uploadedReport/:id"
                        element={<ReportDownload />}
                      />
                    </Route>
                  </>
                ) : (
                  <Route path="/reports" element={<SubscriptionMessage />} />
                )}
                {subscriptions.includes("Survey") ? (
                  <>
                    <Route path="/survey">
                      <Route
                        index
                        element={<Navigate to="report-database" replace />}
                      />
                      <Route path=":source" element={<Survey />} />

                      <Route
                        path="uploadedSurvey/:id"
                        element={<SurveyDownload />}
                      />
                    </Route>
                  </>
                ) : (
                  <Route path="/survey" element={<SubscriptionMessage />} />
                )}
                <Route path="/insights" element={<Insights />} />

                {subscriptions.includes("Social Media") ? (
                  <Route path="/socialmedia">
                    <Route
                      index
                      element={<Navigate to="socialmedia" replace />}
                    />
                    <Route path=":source" element={<SocialMedia />} />
                  </Route>
                ) : (
                  <Route
                    path="/socialmedia"
                    element={<SubscriptionMessage />}
                  />
                )}

                {/******** DIRECTORY *******************/}

                {/* <Route path='/directory' element={<Directory />} /> */}

                <Route path="/directory">
                  <Route
                    index
                    element={<Navigate to="party-members" replace />}
                  />
                  <Route path=":source" element={<Directory />} />
                </Route>

                <Route path="/chatModule">
                  <Route
                    index
                    element={<Navigate to="contacts" replace />}
                  />
                  <Route path=":source" element={<Chat />} />
                </Route>

                <Route
                  exact
                  path="/eventScheduler"
                  element={<EventScheduler />}
                />

                <Route
                  exact
                  path="/powerbi-module"
                  element={<PowerBIModule />}
                />
                <Route
                  path="/powerbi-module/:id"
                  element={<PowerBiReportPage />}
                />

                <Route
                  exact
                  path="/speech-module"
                  element={<SpeechModule />}
                />
                <Route
                  path="/speech-module/:id"
                  element={<SpeechReportPage />}
                />

                {/* <Routes>
                  <Route path="/powerbi-module" element={<PowerBIModule />} />
                  <Route path="/report/:id" element={<PowerBiReportPage />} />
                </Routes> */}

                {/* <Route path="/customersupport" element={<CustomerSupport />} /> */}
                <Route path="/notifications" element={<Notifications />} />
                <Route
                  path="*"
                  // element={<Navigate to={defaultRoute} replace />}
                  element={<Navigate to="/dashboardtest" replace />}
                />
                {/* <Route exact path="/dashboard" element={<Overview />} /> */}
                <Route path="/helpcenter" element={<HelpCenter />} />

                {/* <Route path="/users" element={<Users />} />
                <Route
                  path="/assets-management"
                  element={<AssetsManagement />}
                />
                <Route path="/assetsManagement/user" element={<ClientUser />} /> */}
                <Route path="/assets-management">
                  <Route index element={<Navigate to="office" replace />} />
                  <Route path=":source" element={<AssetsManagement />} />
                </Route>
                <Route path="/assets-management/user/:userId">
                  <Route index element={<Navigate to="grievances" replace />} />
                  <Route path=":source" element={<UserInfo />} />
                </Route>
                <Route
                  path="/assets-management/user/userInfo/grievanceuserinfo/:gmsUserId"
                  element={<GrievanceUserInfo />}
                />
                <Route
                  path="/assets-management/user/userInfo/taskuserinfo/:tmsUserId"
                  element={<TaskUserInfo />}
                />
                {/* <Route path="/assetsManagement/organizatinal-hierarchy" element={<OrganizationalHierarchy />} /> */}
                {/* <Route path='/cadremanagment' element={<Cadre />} /> */}
                <Route path="/reports" element={<Reports />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/survey" element={<Survey />} />
                {/* <Route path="/customersupport" element={<CustomerSupport />} /> */}
                <Route path="/customersupport">
                  <Route
                    index
                    element={<Navigate to="all-tickets" replace />}
                  />
                  <Route path=":source" element={<CustomerSupport />} />
                </Route>
                <Route path="/notifications" element={<Notifications />} />
                {/* <Route path='/gms'>
                  <Route index element={<Navigate to='gms' replace />} />
                  <Route path=':source' element={<GmsTab />} />

                  <Route
                    index
                    element={<Navigate to='all-tickets' replace />}
                  />
                  <Route path=':source' element={<CustomerSupport />} />
                </Route> */}
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/settings">
                  <Route index element={<Navigate to="general" replace />} />
                  <Route path=":source" element={<Tabsettings />} />
                </Route>
              </Routes>
            </div>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/login/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/api/clients/auth/passwordReset"
            element={<ResetPassword />}
          />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </Router>
  );
};

export default RouteApp;
